import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import { useAuth } from '../../../contexts/AuthContext';
import { Plus, ChevronRight, Truck, Trash2 } from 'lucide-react';

export default function TransportadorasLista() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const loadList = () => {
    setLoading(true);
    api.get('/transportadoras').then(r => setList(r.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { loadList(); }, []);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await api.delete(`/transportadoras/${deleteTarget.id}`);
      setDeleteTarget(null);
      loadList();
    } catch (err) {
      alert(err.response?.data?.detail || 'Erro ao excluir');
    } finally { setDeleting(false); }
  };

  return (
    <div data-testid="transportadoras-lista">
      {deleteTarget && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="confirm-delete-modal">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-2xl">
            <h3 className="font-dashboard font-bold text-lg text-brand-text mb-2">Confirmar exclusão</h3>
            <p className="text-sm font-body text-brand-text-muted mb-1">
              Excluir permanentemente <strong className="text-brand-text">"{deleteTarget.label}"</strong>?
            </p>
            <p className="text-xs text-amber-600 font-body mb-5">Esta ação não pode ser desfeita.</p>
            <div className="flex gap-3">
              <button onClick={() => setDeleteTarget(null)} className="flex-1 py-2 rounded-lg border border-brand-border text-sm font-dashboard text-brand-text-muted hover:bg-brand-bg" data-testid="cancel-delete-btn">Cancelar</button>
              <button onClick={handleDelete} disabled={deleting} className="flex-1 py-2 rounded-lg bg-red-600 text-white text-sm font-dashboard font-semibold hover:bg-red-700 disabled:opacity-60" data-testid="confirm-delete-btn">{deleting ? 'Excluindo...' : 'Excluir'}</button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-6">
        <div><h1 className="dashboard-heading text-2xl">Transportadoras / Entregadores</h1><p className="text-brand-text-muted font-body text-sm">{list.length} cadastro(s)</p></div>
        <Link to="/admin/transportadoras/nova" className="flex items-center gap-2 py-2 px-4 rounded-lg btn-primary font-dashboard font-semibold text-sm" data-testid="new-transp-btn"><Plus className="w-4 h-4" /> Novo</Link>
      </div>
      <div className="card-dashboard overflow-x-auto">
        {loading ? <div className="flex justify-center py-12"><div className="w-6 h-6 border-4 border-brand-primary border-t-transparent rounded-full animate-spin" /></div> :
          list.length === 0 ? <p className="text-center text-sm py-12 text-brand-text-muted font-body">Nenhum cadastro</p> : (
          <table className="w-full text-sm font-body">
            <thead><tr className="border-b border-brand-border bg-brand-bg">
              <th className="text-left py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Nome</th>
              <th className="text-left py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Tipo</th>
              <th className="text-left py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Pessoa</th>
              <th className="text-center py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Status</th>
              <th className="py-2.5 px-3"></th>
            </tr></thead>
            <tbody>
              {list.map(t => (
                <tr key={t.id} className="border-b border-brand-border last:border-0 hover:bg-brand-bg/50">
                  <td className="py-2.5 px-3 font-medium text-brand-text">{t.nome || t.nome_fantasia}</td>
                  <td className="py-2.5 px-3 text-brand-text-muted">{t.tipo}</td>
                  <td className="py-2.5 px-3 text-brand-text-muted">{t.tipo_pessoa === 'F' ? 'Pessoa Física' : 'Pessoa Jurídica'}</td>
                  <td className="py-2.5 px-3 text-center"><span className={`text-xs px-2 py-0.5 rounded-full font-medium ${t.is_ativo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{t.is_ativo ? 'Ativo' : 'Inativo'}</span></td>
                  <td className="py-2.5 px-3">
                    <div className="flex items-center gap-2">
                      <Link to={`/admin/transportadoras/${t.id}`} className="text-brand-primary hover:text-brand-dark" data-testid="edit-transp-btn"><ChevronRight className="w-4 h-4" /></Link>
                      {isAdmin && t.is_ativo && (
                        <button
                          onClick={() => setDeleteTarget({ id: t.id, label: t.nome || t.nome_fantasia })}
                          className="text-red-400 hover:text-red-600 transition-colors"
                          title="Excluir transportadora"
                          data-testid="delete-transp-btn"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
